import API from '../dataApi';

// -- Support -------------------------------------------------------------------
export const submitSupport        = (data)     => API.post('/support', data);
export const checkSupportTicket   = (ticketNo, email) => API.get(`/support/check/${ticketNo}`, { params: { email } });
export const getMyTickets         = ()         => API.get('/support/my');
export const getSupportTickets    = (status)   => API.get('/support', { params: { status } });
export const resolveTicket        = (id, data) => API.put(`/support/${id}/resolve`, data);
export const updateTicketStatus   = (id, status) => API.put(`/support/${id}/status`, { status });
